import React from "react";
import Camera from "./camera.svg";
import { connect } from 'react-redux';

class CameraPanel extends React.Component{

    constructor(props){
        super(props);
    }
    componentDidUpdate(){
        
    }
    render(){
        return (
            <div style={{alignSelf:"center",width:"480px",height:"360px",backgroundColor:"white" ,border:"1px solid grey"}}>
                {!this.props.isCameraEnabled?<img src={Camera} width="50px" height="50px" style={{marginTop:"9rem",position:"relative"}}/>:null}
                <video id= "myVideo"width={"480px"} height={"100%"} />
            </div>
        )
    }
} 

const mapStateToProps = state =>{
    return {
        isCameraEnabled: state.menuBarReducer.isCameraEnabled
    }
}

export default connect(mapStateToProps)(CameraPanel);